import React from "react";
import {
  DropboxArrowIcon,
  InfoIcon,
} from "../../../../../components/GlobalIcons";

import "./style.css";

const DropBoxPop = ({
  title,
  info,
  jsonInfo,
  ticket_type,
  delivery,
  Seating,
  icon
}) => {

  return (
    <div className="Dropbox_pop">
      <span className="drop_icon">
        <DropboxArrowIcon />
      </span>
      <div className="Drop_box_content">
        <h3>
          <span>
            {icon}
          </span>{" "}
          {/* Information */}
          {title}
        </h3>
        <div className="drop_bottom_content">
          {jsonInfo && (
            <div
              dangerouslySetInnerHTML={{
                __html:
                  jsonInfo &&
                  jsonInfo?.en_GB
              }}
            />
          )}
          {info && <p>{info}</p>}
          {ticket_type && <p>Ticket type: {ticket_type}, home section</p>}
          {delivery && (
            <p>
              Delivery: Your tickets will be delivered at least {delivery}
              ahead of the event
            </p>
          )}
          {Seating && (
            <p>
              Seating: A minimum of {Seating} seats are guaranteed to be sitting
              together for this event
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default DropBoxPop;
